import { Controller } from "@hotwired/stimulus"

// Client-side tab switching controller for inline tab panels.
// Unlike the route-based tabs used elsewhere in the app, this controller
// switches panels within a single page without navigation.
//
// Usage:
//   <div data-controller="inline-tabs">
//     <button data-inline-tabs-target="tab" data-action="inline-tabs#select"
//             data-inline-tabs-index-param="0">Tab 1</button>
//     <div data-inline-tabs-target="panel">Panel 1</div>
//     <div data-inline-tabs-target="panel" class="hidden">Panel 2</div>
//   </div>
export default class extends Controller {
  static targets = ["tab", "panel"]

  static classes = ["active", "inactive"]

  connect() {
    this.select({ params: { index: 0 } })
  }

  select({ params: { index } }) {
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.className = this.activeClasses.join(" ")
      } else {
        tab.className = this.inactiveClasses.join(" ")
      }
    })
  }
}
